import { apiRequest } from "../utils/http.js";

export async function listStaffRoles() {
  return (await apiRequest("api/roles")) || [];
}